// import "./App.css";
import { getFirestore } from "firebase/firestore";
import React from "react";
import { FirestoreProvider, useFirebaseApp } from "reactfire";

import Main from "./game/Main";

function App() {
  const app = useFirebaseApp();
  const firestoreInstance = getFirestore(app);

  return (
    <div className="App">
      <FirestoreProvider sdk={firestoreInstance}>
        <Main />
      </FirestoreProvider>
    </div>
  );
}

export default App;
